import React, { useEffect, useState } from 'react';
import Bienvenido from "components/bienvenido";
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import { isBrowser } from "react-device-detect";

const Home = ({ label, onToggleDetail, initState = true }) => {
    const [showDetail, setShowDetail] = useState(initState);
    
    useEffect(() => {
        setShowDetail(initState);
    }, [initState])

    const handleChangeSetShowDetail = () => {
        setShowDetail(!showDetail);
        onToggleDetail(!showDetail)
    }

    return (
        <div>
            <div className={'display-flex space-between center-vertical '}>
                <div>
                </div>
                {/* <Button 
                    onClick={handleChangeSetShowDetail} 
                    variant="primary">{showDetail ? 'Editar datos' : 'Cancelar edición'}
                </Button>  */}
                {
                    isBrowser &&
                    <Bienvenido />
                }
            </div>
            <br />
            <Card>
                <Card.Body> 
                    <b> 
                        <span className="fs-25" > 
                            <span className="color-azul-oscuro"> 
                                {label} 
                            </span> 
                            { showDetail && 
                                <span className="color-gris"> 
                                    {' '} |
                                </span>
                            }
                            {' '}
                            
                        </span> 
                        {   showDetail && 
                            <div className="color-gris cursor-pointer inline"> 
                                <button onClick={handleChangeSetShowDetail} style={{ border: 0, padding: 0, fontSize: '100%', fontFamily: 'inherit', background: 'none', color: '#636e72' }}> 
                                    <b> 
                                        Añadir/editar datos <i class="fas fa-pen"></i> 
                                    </b> 
                                </button>   
                            </div> 
                        }
                    </b>  
                </Card.Body>
            </Card>
            <br />
        </div>
    );
}

export default Home;
